export default __webpack_public_path__ + "static/1-9f86854bd910b7951ff54c7259027de8.jpg";